import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const clean = (text, max) => String(text || "").trim().replace(/\s+/g, " ").slice(0, max);
const sameKey = (text) => clean(text, 200).toLocaleLowerCase("tr");

// One knowledge base topic: pick one from the list (it replaces the current one), or type a
// name the list lacks and choose "New topic" at the top.
const TopicSelect = ({ value, onChange, topics, placeholder, maxLength = 60, className, allowClear, disabled }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const typed = clean(search, maxLength);
  const known = [...new Set([...(topics || []), ...(value ? [value] : [])])];
  const isNew = !!typed && !known.some((topic) => sameKey(topic) === sameKey(typed));
  const options = [
    ...(isNew
      ? [
          {
            value: typed,
            label: (
              <span>
                <PlusOutlined /> {t("surveySettings.topic_new", { topic: typed })}
              </span>
            ),
          },
        ]
      : []),
    ...known.map((topic) => ({ value: topic, label: topic })),
  ];

  return (
    <Select
      showSearch
      value={value || undefined}
      searchValue={search}
      onSearch={setSearch}
      onChange={(next) => {
        onChange(clean(next, maxLength));
        setSearch("");
      }}
      onBlur={() => setSearch("")}
      filterOption={(input, option) => option.value === typed || sameKey(option.value).includes(sameKey(input))}
      options={options}
      placeholder={placeholder}
      className={className}
      allowClear={allowClear}
      disabled={disabled}
      notFoundContent={null}
    />
  );
};

export default TopicSelect;
